import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Card, Icon } from 'antd';
import { FaBinoculars } from 'react-icons/fa'
import { ethers } from 'ethers';




@observer(["ViewStore", "web3Store"])
class Oracles extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    async componentWillMount() {
        this.props.ViewStore.changeView('Oracles');
        this.props.ViewStore.changeCurrentPage('Oracles');
    }


    async componentDidMount() {
        let address = "0x668D27cb04F621727316fb0444D66b9cF5A3eF22";

        //     var address = await ens.resolver('alice.eth').addr();
        let defaultProvider = new ethers.providers.Web3Provider(this.props.web3Store.web3.currentProvider);
        defaultProvider.resolveName('timmccull.test').then((address) => {
            console.log("ENS add: " + address);
        })

        defaultProvider.lookupAddress(address).then((name) => {
            console.log("name " + name);
        });
        // Check to be sure the reverse record is correct.
        // if (address != await defaultProvider.resolveName(name)) {
        //     name = null;
        // }





    }


    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('Oracles')
    }

    render() {

        return (

            <Card bordered={false} style={{ color: 'rgb(255,255,255)', background: '#011828', borderRadius: '4px', marginBottom: '85px' }} >
                <div className="main-page-cards-event-info">
                    <br />
                    <h2 >Welcome to the Oracle Page!</h2>

                    {/* <img width="7%" height="7%"  src="https://imgur.com/6xQ1i35.png" /> */}
                    <FaBinoculars style={{ fontSize: "40pt", color: "#3296f7" }} />
                    <h4>Here is where you will view and action your Oracle registry.</h4>
                    <br />
                    <br />



                    <h3>What are Oracles?</h3>
                    <p>Oracles are people who report the outcomes of events to the meVu platform. Disputed bets use the results provided by Oracles to determine the winner.</p>
                    <br />
                    <br />
                    <h3>How does it work?</h3>
                    <p>After an event (ex. hockey game) has completed, there is a window of time known as the 'Oracle Period' where verified Oracles may vote on the winner of the event.
                    In order
                    to vote, and in the same transaction, an Oracle must send some MVU tokens they own to the meVu platform to be held in escrow. Upon conclusion of the Oracle Period,
                    Oracles with consensus may claim
                    their reward corresponding to a particular event and they will be sent a percentage of the pool of fees earned from bets on that event.
                    The percentage earned by any one Oracle
                    will be proportianate to their percentage of total MVU staked by Oracles on that event. If an Oracle is found to be against consensus the 'claim reward' function
                    results in the return of half of the MVU they sent to the platform as a stake. The other half is distributed amonst Oracles with consensus in the same manner as the
                    ETH fees earned.</p>
                    <br />
                    <br />

                    <h3>Why be an Oracle?</h3>
                    <p>Oracles are rewarded in ETH and MVU tokens for their service. All Oracles with consensus will recieve some ETH from the bet fees and they may also recieve MVU depending on
                    their stake and how many Oracles were against consensus. Being an Oracle allows a user to earn ETH with minimal risk.</p>
                    <br />
                    <br />

                    <h3>When will the Oracle function be live?</h3>
                    <p>We hope to have the Oracle funcitonality rolled out to users in 2019.</p>
                    <br />
                    <br />

                    <h3>How do I become an Oracle?</h3>
                    <p>To become an Oracle users must sign up to be verified, more details on this process will be made available closer to the date the verification process opens.</p>
                    <br />
                    <br />
                    <p>For more detailed information on Oracles and how our entire platform works please read our whitepaper available for download
                  on <a href='https://mevu.bet'>mevu.bet</a></p>
                </div>
            </Card>

        );
    }
}

export default inject('store')(observer(Oracles));


// WEBPACK FOOTER //
// ./src/components/appComponents/Oracles.js